import { render, staticRenderFns } from "./boxcode.vue?vue&type=template&id=4445574a&scoped=true"
import script from "./boxcode.vue?vue&type=script&lang=js"
export * from "./boxcode.vue?vue&type=script&lang=js"
import style0 from "./boxcode.vue?vue&type=style&index=0&id=4445574a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4445574a",
  null
  
)

export default component.exports